import { TemplateLayout } from '../../store/interfaces';

export const getTemplateLayout = (templateLayout: TemplateLayout | null): TemplateLayout => {
  const layout = !templateLayout ? TemplateLayout.TEMPLATE_LAYOUT_01 : templateLayout;
  return layout;
};

export const isJourneyTheme = (layout?: TemplateLayout): boolean => {
  return !!layout && (layout === TemplateLayout.TEMPLATE_LAYOUT_02 || layout === TemplateLayout.TEMPLATE_LAYOUT_04);
};
